"use strict";
// gcd
exports.__esModule = true;
function gcd(x, y) {
    x = Math.abs(x);
    y = Math.abs(y);
    while (y) {
        var t = y;
        y = x % y;
        x = t;
    }
    return x;
}
exports["default"] = gcd;
